export interface WebNotificationPayload {
  id?: number;
  title: string;
  message: string;
  link?: string;
}

const PERMISSION_KEY = 'webNotificationsAsked';

export function isWebNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function getWebNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!isWebNotificationSupported()) return 'unsupported';
  return Notification.permission;
}

/** Ask once when the admin panel loads (requires a user gesture on some browsers). */
export async function requestWebNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!isWebNotificationSupported()) return 'unsupported';
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Notification.permission;
  }
  if (localStorage.getItem(PERMISSION_KEY) === 'true') {
    return Notification.permission;
  }
  localStorage.setItem(PERMISSION_KEY, 'true');
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function showWebNotification(payload: WebNotificationPayload): void {
  if (!isWebNotificationSupported() || Notification.permission !== 'granted') return;

  const title = payload.title || 'Darb ERP';
  const body = payload.message || '';
  const tag = payload.id ? `darb-notification-${payload.id}` : `darb-notification-${Date.now()}`;

  try {
    const notification = new Notification(title, {
      body,
      tag,
      icon: '/cropped-pixelcut-export-removebg-2048x691.png',
      badge: '/cropped-pixelcut-export-removebg-2048x691.png',
    });

    notification.onclick = () => {
      window.focus();
      if (payload.link) {
        window.location.href = payload.link.startsWith('/') ? payload.link : `/${payload.link}`;
      }
      notification.close();
    };
  } catch {
    // Browser blocked or unsupported context
  }
}
